// extracted by mini-css-extract-plugin
export default {"host":"Media_host__EOh4S"};